<template>
  <ElPopover
    v-model:visible="isPopoverVis"
    placement="bottom-end"
    trigger="click"
    popper-class="boookmarks"
  >
    <template v-slot:reference>
      <div
        ref="bookmarkMain"
        :class="{'bookmark-title-disabled': bookmarks.length === 0 && searchBookmarkText.length === 0}"
        class="tabs-right-btn__bookmarks"
      >
        <UiIcon
          name="star"
          size="13px"
          color="#ffce06"
          class="tab-action"
        />
        <!-- <span>{{ $t('reports.other.bookmark') }}</span> -->
        <UiIcon
          :color="`#ffffff`"
          size="9px"
          name="chevron-left"
          :class="{'tabs-right-btn__chevron--open': isPopoverVis}"
          class="tab-action tabs-right-btn__chevron"
        />
      </div>
    </template>

    <template v-slot>
      <div
        v-if="isPopoverVis"
        v-loading="isLoadingBookmark"
      >
        <div class="search-input-popover__wrap">
          <UiInput
            v-model="searchBookmarkText"
            is-search
            class="search-input-popover"
          />
        </div>
        <div class="select-row-popover__wrapper-list">
          <div
            v-for="(item, key) in localBookmarks"
            :key="item.key"
            class="select-row-popover"
            @mouseover.prevent.stop="showPopperEditDel(key)"
            @click="pushBookmark(key); closeAllBookmark()"
          >
            <span class="select-row-popover__title">{{ item.bookmarkName }}</span>
            <div
              v-if="bookmarkRenderPopover[key]"
              class="select-row-popover__wrap"
            >
              <ElPopover
                ref="popoverref"
                v-model:visible="isPopoverEdit[key]"
                placement="bottom-end"
                trigger="click"
                popper-class="boookmark-edit boookmark-edit-ls"
                :teleported="false"
              >
                <template v-slot:reference>
                  <span
                    :class="{'select-row-popover__edit--active': isPopoverEdit[key]}"
                    class="select-row-popover__edit"
                    @click.stop="actionBookmarkName('Edit', item.bookmarkName)"
                  >{{ $t('reports.other.edit') }}</span>
                </template>
                <div
                  ref="poplist"
                  @click.stop
                >
                  <UiInput
                    v-model="constBookmarkName"
                    placeholder
                    :label="$t(`reports.other.bookmark_edit`)"
                    class="boookmark-edit__input"
                  />
                  <div class="boookmark-edit__wrap-btn">
                    <UiButton
                      class="boookmark-edit__close"
                      type="negative"
                      icon="times"
                      @click="actionBookmarkName('Show')"
                    >
                      {{ $t('reports.other.close') }}
                    </UiButton>
                    <UiButton
                      class="boookmark-edit__success"
                      filled
                      icon="check"
                      @click="saveEditBookmarkName(key); actionBookmarkName('Show')"
                    >
                      {{ $t('reports.other.save') }}
                    </UiButton>
                  </div>
                </div>
              </ElPopover>

              <ElPopover
                ref="popoverdel"
                v-model:visible="isPopoverDelete[key]"
                trigger="click"
                placement="bottom"
                popper-class="boookmark-delete"
                :teleported="false"
              >
                <template v-slot:reference>
                  <span
                    :class="{'select-row-popover__delete--active': isPopoverDelete[key]}"
                    class="select-row-popover__delete"
                    @click.stop="actionBookmarkName('Delete')"
                  >{{ $t('reports.other.delete') }}</span>
                </template>

                <div
                  class="boookmark-delete__wrap-btn"
                  style="text-align: right; margin: 0"
                  @click.stop
                >
                  <div
                    class
                    style="text-align: right; margin: 0"
                  >
                    <UiButton
                      class="boookmark-delete__close"
                      type="negative"
                      icon="times"
                      @click="actionBookmarkName('Show')"
                    >
                      {{ $t('reports.other.close') }}
                    </UiButton>
                    <UiButton
                      class="boookmark-delete__success"
                      filled
                      type="negative"
                      icon="times"
                      @click="deleteBookmark(item.uid); actionBookmarkName('Show')"
                    >
                      {{ $t('reports.other.delete') }}
                    </UiButton>
                  </div>
                </div>
              </ElPopover>
            </div>
          </div>
        </div>
        <div v-if="notFoundBookmark">
          <span class="notFoundBookmark">{{ $t('reports.other.not_found_bookmark') }}</span>
        </div>
      </div>
    </template>
  </ElPopover>
</template>

<script>
import datePickerShortcuts from '@/views/mixins/date-picker-shortcuts';

export default {
  name: 'Bookmark',
  mixins: [datePickerShortcuts],
  props: {
    reports: {
      type: Array,
      required: true,
    },
    currentReport: {
      type: Number,
      required: true,
    },
    bookmarks: {
      type: Array,
      required: true,
    },
    isLoadingBookmark: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['update:bookmarks', 'createReport', 'saveBookmark'],
  data() {
    return {
      searchBookmarkText: '',
      isPopoverVis: false,
      isPopoverEdit: [],
      constBookmarkName: '',
      bookmarkRenderPopover: [],
      isPopoverDelete: [],
    };
  },

  computed: {
    notFoundBookmark() {
      return this.localBookmarks.length === 0;
    },
    localBookmarks() {
      return this.searchBookmarkText !== '' ? this.bookmarks.filter((e) => e.bookmarkName.toLowerCase().indexOf(this.searchBookmarkText.toLowerCase()) !== -1) : this.bookmarks;
    },
  },

  watch: {
    isPopoverVis(v) {
      if (v) {
        document.addEventListener('click', this.eventStop, true);
        setTimeout(() => {
          document.querySelector('.select-row-popover__wrapper-list').addEventListener('scroll', () => {
            this.switchToFalse();
            if (this.$refs.popoverref) {
              this.$refs.popoverref.forEach((el, i) => {
                this.$refs.popoverref[i].showPopper = false;
              });
            }
            if (this.$refs.popoverdel) {
              this.$refs.popoverdel.forEach((el, i) => {
                this.$refs.popoverdel[i].showPopper = false;
              });
            }
          });
        });
      } else {
        this.switchToFalse();
        this.searchBookmarkText = '';
      }
    },
  },
  unmounted() {
    document.removeEventListener('click', this.eventStop, true);
  },

  methods: {
    switchToFalse() {
      this.isPopoverEdit = this.isPopoverEdit.map(() => false);
      this.isPopoverDelete = this.isPopoverDelete.map(() => false);
    },
    actionBookmarkName(action, name) {
      if (action === 'Show') {
        this.$refs.popoverdel.forEach((e) => e.showPopper = false);
        this.$refs.popoverref.forEach((e) => e.showPopper = false);
        this.switchToFalse();
      }
      if (action === 'Edit') {
        this.constBookmarkName = name;
        this.switchToFalse();
      }
      if (action === 'Delete') {
        this.switchToFalse();
      }
    },
    saveEditBookmarkName(index) {
      this.bookmarks[index].bookmarkName = this.constBookmarkName;
      this.$emit('update:bookmarks', this.bookmarks);
      this.$emit('saveBookmark');
    },
    eventStop(e) {
      if (this.$refs.bookmarkMain.contains(e.target)) return;
      if (this.$parent.$parent.$el.contains(e.target)) {
        this.isPopoverVis = false;
        this.switchToFalse();
      }
    },
    deleteBookmark(id) {
      const deleteBookmark = this.$_.cloneDeep(this.bookmarks);
      const deleteIndex = this.$_.findIndex(deleteBookmark, (el) => el.uid === id);
      deleteBookmark.splice(deleteIndex, 1);
      this.$emit('update:bookmarks', deleteBookmark);
      this.$emit('saveBookmark');
    },
    closeAllBookmark() {
      this.isPopoverVis = false;
      this.switchToFalse();
    },
    pushBookmark(v) {
      if (this.localBookmarks[v].dateRange.length === 0) {
        const { dateRange, datePeriod } = this.reports[this.currentReport];

        this.$emit('createReport', {
          ...this.localBookmarks[v],
          ...this.checkPeriod({ dateRange, datePeriod }),
        });
      } else {
        const { datePeriod, dateRange, ...restBookmarks } = this.localBookmarks[v];

        this.$emit('createReport', {
          ...restBookmarks,
          ...this.checkPeriod({ dateRange, datePeriod }),
        });
      }
    },
    showPopperEditDel(key) {
      this.bookmarkRenderPopover[key] = true;
      this.bookmarkRenderPopover = this.$_.cloneDeep(this.bookmarkRenderPopover);
    },
    // searchBookmark(v) {
    //   this.searchBookmarkText = v || '';
    //   this.$eventBus.$emit('emitGetBookmarksSearch');
    //   this.isPopoverEdit.forEach((el, i) => {
    //     this.isPopoverEdit[i] = false;
    //   });
    // },
  },

};
</script>
